import { useTranslation } from "../hooks/useTranslation";

/**
 * Maps a stored English enum value — salutation (Person::SALUTATIONS), reaction
 * (Visit::REACTIONS), visit status (Visit::STATUSES) or address/phone type — to its
 * translated label via the `contact_info` i18n namespace.
 *
 * Display-ONLY, exactly like useCategoryName: the stored/emitted value stays the
 * canonical English string (backend validation is `in:Mr,Mrs,...`, `in:Completed,...`,
 * reactions are stored as an integer scale), so this only affects what the user sees.
 * Unknown values fall through unchanged.
 */
const VALUE_TO_KEY: Record<string, string> = {
  // Salutations
  Mr: "mr", Mrs: "mrs", Ms: "ms", Dr: "dr", Rabbi: "rabbi",
  // Reactions — note "Not interested" uses the existing key `rude`
  Happy: "happy", Warm: "warm", Neutral: "neutral", Cold: "cold", "Not interested": "rude",
  // Visit statuses
  Completed: "completed", Deferred: "deferred",
  // Address & phone types
  Home: "home", Work: "work", Mobile: "mobile", Other: "other",
};

export const useContactEnumLabel = () => {
  const { p } = useTranslation("contact_info");
  return (value?: string | null): string => {
    if (value === null || value === undefined || value === "") return value ?? "";
    const key = VALUE_TO_KEY[value];
    return key ? p(key, { defaultValue: value }) : value;
  };
};
